export const isLowerThanIE11 = () => navigator.userAgent.indexOf('MSIE') >= 0;

export const isIE = () => navigator.userAgent.indexOf('MSIE') >= 0 || navigator.userAgent.indexOf('Trident/') >= 0;
